<template>
  <b-container fluid class="bg-white">
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-10">
        <div class="lz-page-card">
          <div v-if="loading" class="lz-empty-state">
            <b-spinner small class="mb-2"></b-spinner>
            <p>Loading your requests...</p>
          </div>
          <div v-else-if="!showTable" class="lz-empty-state">
            <b-icon icon="calendar2-week" class="lz-empty-icon"></b-icon>
            <p>There aren't any leave requests to show here yet.</p>
          </div>
          <template v-else>
            <b-table
              caption-top
              responsive
              fixed
              striped
              small
              borderless
              table-class="lz-data-table lz-holiday-table"
              :items="listItems"
              :fields="listFields"
              :per-page="pager.perPage"
              :current-page="pager.currentPage"
              :busy="loading">
              <template #table-caption>Submitted Requests</template>
              <template #cell(submitted)="data">
                {{ formatDate(data.item.submitted) }}
              </template>
              <template #cell(startDate)="data">
                {{ formatDate(data.item.startDate) }}
              </template>
              <template #cell(endDate)="data">
                {{ formatDate(data.item.endDate) }}
              </template>
              <template #cell(type)="data">
                {{ data.item.type.toUpperCase() }}
              </template>
              <template #cell(notes)="data">
                <span v-b-popover.hover.top="data.item.comments.user">
                  {{ summarize(data.item.comments.user || '') }}
                </span>
              </template>
              <template #cell(comment)="data">
                <span v-b-popover.hover.top="data.item.comments.manager">
                  {{ summarize(data.item.comments.manager || '') }}
                </span>
              </template>
              <template #cell(status)="data">
                <b-badge
                  class="lz-status-badge"
                  :variant="GetHolidayStatusVariant(data.item.status)">
                  {{ data.item.status.toUpperCase() }}
                </b-badge>
              </template>
              <template #cell(refCode)="data">
                <b-badge
                  class="lz-code-badge"
                  v-if="data.item.refCode"
                  style="cursor: pointer"
                  title="Click to copy"
                  @click="copyRefCode(data.item)">
                  {{ data.item.refCode }}
                </b-badge>
              </template>
              <template #cell(action)="data">
                <b-link
                  class="lz-cancel-link"
                  @click="doRemove(data.item.uid)"
                  v-if="data.item.status === 'pending'">
                  <b-icon
                    icon="x-square-fill"
                    title="Cancel the Request"></b-icon>
                  Cancel</b-link
                >
              </template>
            </b-table>
            <b-pagination
              v-if="listItems.length > pager.perPage"
              v-model="pager.currentPage"
              :total-rows="listItems.length"
              :per-page="pager.perPage"
              size="sm"
              pills
              class="lz-pagination"
              align="center"></b-pagination>
          </template>
        </div>
      </div>
      <div class="col-lg-1"></div>
    </div>
  </b-container>
</template>

<script>
import ServicesOld from '../../../services/index.vue'
import { format as dateFormat } from 'date-fns'

export default {
  name: 'HolidayList',
  props: {
    selectedYear: {
      type: Number,
      required: true
    },
    mobileView: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    listFields() {
      const flds = [
        {
          key: 'submitted',
          label: 'Submitted Date',
          sortable: true,
          thClass: 'w10 aleft',
          tdClass: 'w10 aleft',
          _showInMobileView: false
        },
        {
          key: 'type',
          label: 'Type',
          sortable: true,
          thClass: 'w40 aleft',
          tdClass: 'w40 aleft',
          _showInMobileView: true
        },
        {
          key: 'startDate',
          label: 'From',
          sortable: true,
          thClass: 'w10',
          tdClass: 'w10',
          _showInMobileView: true
        },
        {
          key: 'endDate',
          label: 'To',
          sortable: true,
          thClass: 'w10',
          tdClass: 'w10',
          _showInMobileView: true
        },
        {
          key: 'totalDays',
          label: 'Days requested',
          thClass: 'w10',
          tdClass: 'w10',
          _showInMobileView: false
        },
        {
          key: 'notes',
          label: 'Notes',
          thClass: 'w10',
          tdClass: 'w10',
          _showInMobileView: false
        },
        {
          key: 'comment',
          label: 'Manager comment',
          thClass: 'w10',
          tdClass: 'w10',
          _showInMobileView: false
        },
        // {
        //   key: 'refCode',
        //   label: 'Reference Code',
        //   thClass: 'w10',
        //   tdClass: 'w10',
        //   _showInMobileView: false
        // },
        {
          key: 'status',
          label: 'Status',
          thClass: 'w10',
          tdClass: 'w10',
          _showInMobileView: true
        },
        {
          key: 'action',
          label: '',
          thClass: 'w10',
          tdClass: 'w10',
          _showInMobileView: true
        }
      ]
      return flds.filter((fld) => {
        return this.mobileView ? fld._showInMobileView : true
      })
    }
  },
  data: () => {
    return {
      loading: true,
      showTable: true,
      listItems: [],
      pager: {
        currentPage: 1,
        perPage: 10
      }
    }
  },
  async mounted() {
    this.$root.$on('parent_tab_holidays_selected', this.tabMounted)
    this.$root.$on('saved', this.tabMounted)
  },
  methods: {
    async tabMounted() {
      this.loading = true
      this.listItems = await this.GetList()
      this.loading = false
      this.showTable = this.listItems.length
      this.$store.commit('setApprovedHolidays', this.listItems)
    },
    summarize(note) {
      note = note.trim()
      if (note.length > 20) {
        return note.substring(0, 20) + '...'
      } else {
        return note
      }
    },
    async GetList() {
      let { status, data } = await ServicesOld.GetHolidays(null, {
        year: this.selectedYear
      })
      if (status === 200) {
        return data.content
          .map((itm) => {
            if (itm.type.toLowerCase() === 'half-day' && itm.meridiem) {
              itm.type = itm.type + ' (' + itm.meridiem.toUpperCase() + ')'
            }
            switch (true) {
              case itm.type.toLowerCase() === 'annual holiday':
                itm.type = 'Holiday'
                break
              case /^half\-day.+/.test(itm.type.toLowerCase()):
                itm.type = itm.type + ' Holiday'
                break
            }
            return itm
          })
          .sort((a, b) => {
            if (a.submitted > b.submitted) return -1
            if (a.submitted < b.submitted) return 1
            return 0
          })
      } else {
        return []
      }
    },
    doRemove(uid) {
      try {
        const itemIndex = this.listItems.findIndex(
          (itm) => itm.uid === uid && itm.status
        )
        this.loading = itemIndex !== -1
        if (this.loading) {
          ServicesOld.RemoveHoliday(uid)
            .then((resp) => {
              this.loading = false
              if (resp.status === 200) {
                this.listItems.splice(itemIndex, 1)
                this.showTable = this.listItems.length
              }
            })
            .catch((err) => {
              this.loading = false
              console.error(err)
              throw new Error(err.message)
            })
        }
      } catch (err) {
        this.loading = false
        console.error(err)
      }
    },
    GetHolidayStatusVariant(status) {
      let variant = 'light'
      switch (status.toLowerCase()) {
        case 'approved':
          variant = 'success'
          break
        case 'rejected':
          variant = 'danger'
          break
        case 'pending':
          variant = 'warning'
          break
        case 'failed':
          variant = 'dark'
          break
      }
      return variant
    },
    copyRefCode({ refCode = null }) {
      if (refCode === null) {
        return
      }
      navigator.clipboard.writeText(refCode).then(
        () => {
          this.$toasted.show('Reference code copied to clipboard', {
            type: 'info',
            duration: 3000
          })
        },
        function (err) {
          console.error('Could not copy text: ', err)
        }
      )
    },
    formatDate(dt) {
      return dateFormat(new Date(dt), 'dd/MM/yyyy')
    }
  },
  watch: {
    selectedYear: {
      handler: 'tabMounted',
      immediate: true
    }
  }
}
</script>
